import { render, staticRenderFns } from "./NotAuthenticated.vue?vue&type=template&id=a6f0ba50&"
import script from "./NotAuthenticated.vue?vue&type=script&lang=js&"
export * from "./NotAuthenticated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports